export default function(data) {
  var self = this;
  self.certificates = ko.observableArray([]);

  self.bindData = function() {
    var mapping = {
      'create': function(opts) {
        var subMap = {
          'certificates': {
            'update': function(_opts) {
              return ko.mapping.fromJS(_.extend(_opts.data, {
                'sharing': false
              }));
            }
          }
        };
        return ko.mapping.fromJS(opts.data, subMap);
      }
    };
    var mapped = ko.mapping.fromJS(data, mapping);
    self.certificates(mapped.certificates());
  };

  self.initSortable = function() {
    $('#js-certificate-gallery').sortable({
      items: '.js-sortable',
      update: function (e, ui) {
        self.sortCertificates();
      }
    }).sortable('enable');
  };

  self.disableSortable = function() {
    if ($('#js-certificate-gallery').hasClass('ui-sortable')) {
      $('#js-certificate-gallery').sortable('disable');
    }
  };

  self.sortCertificates = function() {
    var data = {certificate: []};
    $('#js-certificate-gallery .js-sortable').each(function (idx, item) {
      var cert = ko.dataFor(item);
      cert.order(idx + 1);
      data['certificate'].push(cert.id());
    });

    var request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.sort_certificates_path(),
      data: data
    });

  };

  self.showShareModal = function(item,event) {
    var params = {modal_title: 'Share Certificate', shareableObj: { share_url: item.user.share_link(), code: item.code() }, emailShareCb: self.shareCertificate};
    var modal = new Kadenze.ShareModal(params);
    modal.show();
  };

  self.shareCertificate = function(item, emails) {
    // var request = new Kadenze.AjaxRequest({
    //   type: 'POST',
    //   url: Kadenze.Routes.share_certificate_path(item.code),
    //   data: {emails: emails}
    // });

    // request.done(function(res) {
      console.log('This feature is not available for now.');
    // });

    // request.fail(function(xhr, status, msg) {
    //   if (xhr.responseJSON) {
    //     msg = xhr.responseJSON.message;
    //   }
    //   new Kadenze.Notice.error({message: msg});
    // });
  };

  self.savePrivacy = function(cert) {
    var data = {certificate: {privacy_level: cert.privacy_level() }};
    var request = new Kadenze.AjaxRequest({
      type: 'PATCH',
      url: Kadenze.Routes.certificate_path(cert.code()),
      data: data
    });

    request.done(function(response) {
      console.log('privacy saved');
    });

    request.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.message;
      }
      new Kadenze.Notice.error({message: msg});
    });
  };


  const __construct = function(that) {
    that.bindData(data);
  }(this);
}
